/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfShortUrl } from '../models';
// @ts-ignore
import type { BfShortUrlRequest } from '../models';
/**
 * URLShortenerApi - axios parameter creator
 */
export const URLShortenerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The user will be redirected to this url
         * @summary Create short url
         * @param {BfShortUrlRequest} bfShortUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShortUrl: async (bfShortUrlRequest: BfShortUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfShortUrlRequest' is not null or undefined
            assertParamExists('createShortUrl', 'bfShortUrlRequest', bfShortUrlRequest)
            const localVarPath = `/v1/url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfShortUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If the url slug is resolved correctly, then redirect the user to the url.
         * @summary Resolve short url
         * @param {string} slug 
         * @param {boolean} [noRedirect] Don\&#39;t redirect and instead return payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortUrl: async (slug: string, noRedirect?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getShortUrl', 'slug', slug)
            const localVarPath = `/v1/url/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (noRedirect !== undefined) {
                localVarQueryParameter['noRedirect'] = noRedirect;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * URLShortenerApi - functional programming interface
 */
export const URLShortenerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = URLShortenerApiAxiosParamCreator(configuration)
    return {
        /**
         * The user will be redirected to this url
         * @summary Create short url
         * @param {BfShortUrlRequest} bfShortUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShortUrl(bfShortUrlRequest: BfShortUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfShortUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShortUrl(bfShortUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['URLShortenerApi.createShortUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * If the url slug is resolved correctly, then redirect the user to the url.
         * @summary Resolve short url
         * @param {string} slug 
         * @param {boolean} [noRedirect] Don\&#39;t redirect and instead return payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShortUrl(slug: string, noRedirect?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfShortUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShortUrl(slug, noRedirect, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['URLShortenerApi.getShortUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * URLShortenerApi - factory interface
 */
export const URLShortenerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = URLShortenerApiFp(configuration)
    return {
        /**
         * The user will be redirected to this url
         * @summary Create short url
         * @param {BfShortUrlRequest} bfShortUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShortUrl(bfShortUrlRequest: BfShortUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<BfShortUrl> {
            return localVarFp.createShortUrl(bfShortUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * If the url slug is resolved correctly, then redirect the user to the url.
         * @summary Resolve short url
         * @param {string} slug 
         * @param {boolean} [noRedirect] Don\&#39;t redirect and instead return payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortUrl(slug: string, noRedirect?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<BfShortUrl> {
            return localVarFp.getShortUrl(slug, noRedirect, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * URLShortenerApi - object-oriented interface
 */
export class URLShortenerApi extends BaseAPI {
    /**
     * The user will be redirected to this url
     * @summary Create short url
     * @param {BfShortUrlRequest} bfShortUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createShortUrl(bfShortUrlRequest: BfShortUrlRequest, options?: RawAxiosRequestConfig) {
        return URLShortenerApiFp(this.configuration).createShortUrl(bfShortUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * If the url slug is resolved correctly, then redirect the user to the url.
     * @summary Resolve short url
     * @param {string} slug 
     * @param {boolean} [noRedirect] Don\&#39;t redirect and instead return payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getShortUrl(slug: string, noRedirect?: boolean, options?: RawAxiosRequestConfig) {
        return URLShortenerApiFp(this.configuration).getShortUrl(slug, noRedirect, options).then((request) => request(this.axios, this.basePath));
    }
}

